import { render, staticRenderFns } from "./MultipleChoiceOneOrManyAnswers.vue?vue&type=template&id=5900f8a9&scoped=true&"
import script from "./MultipleChoiceOneOrManyAnswers.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceOneOrManyAnswers.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleChoiceOneOrManyAnswers.vue?vue&type=style&index=0&id=5900f8a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5900f8a9",
  null
  
)

export default component.exports